var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{staticClass:"video",class:[_vm.playing ? 'is-playing' : '']},[_c('vueVimeoPlayer',{ref:"player",staticClass:"intro-video",style:(_vm.videoStyle),attrs:{"height":"100%","width":"100%","controls":false,"options":{
        autoplay:true,
        muted:true
      },"video-id":"564661128"},on:{"ended":_vm.videoEnded}}),_c('button',{class:[_vm.playing ? 'is-playing' : ''],on:{"click":function($event){_vm.$refs.player.play();
        _vm.$refs.player.unmute();
        _vm.playing = true;}}},[_c('img',{attrs:{"src":require("@/assets/icons/icon_button-play.svg"),"alt":""}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }